<template>
<div class="chapter">
<div class="inner_page">
<p class="small"><i>InterVarsity Press<br/>
  P.O. Box 1400,<br/>
  Downers Grove, IL 60515-1426<br/>
  World Wide Web: <a href="http://www.ivpress.com" target="_blank"><span class="hyperlinks">www.ivpress.com</span></a><br/>
  Email: <a href="mailto:email%40ivpress.com?subject="><span class="hyperlinks">email@ivpress.com</span></a></i></p>
<p class="small"><i>©2014 by Michael Frost</i></p>
<p class="small"><i>All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</i></p>
<p class="small"><i>InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept., InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at <a href="http://www.intervarsity.org" target="_blank"><span class="hyperlinks">www.intervarsity.org</span></a>.</i></p>
<p class="small"><i>All Scripture quotations, unless otherwise indicated, are taken from THE HOLY BIBLE, NEW INTERNATIONAL VERSION®, NIV® Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.™ Used by permission. All rights reserved worldwide.</i></p>
<p class="small"><i>While all stories in this book are true, some names and identifying information in this book have been changed to protect the privacy of the individuals involved.</i></p>
<p class="small"><i>Cover design: Cindy Kiple<br/>
  Image: Face in the Crowd by Evelyn Williams. Private Collection/The Bridgeman Art Library.</i></p>
<p class="small"><i>ISBN 978-0-8308-8405-6 (digital)<br/>
  ISBN 978-0-8308-4417-3 (print)</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?bd6ae1ce